import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";

interface InvoicesHeaderProps {
  totalInvoices: number;
  showJDPointLegacyButton: boolean;
  legacyInventoryUrl: string;
}

const InvoicesHeader = ({
  totalInvoices,
  showJDPointLegacyButton,
  legacyInventoryUrl,
}: InvoicesHeaderProps) => {
  const theme = useTheme();
  const { t } = useTranslation(["common", "invoices"]);

  const openLegacyNewTab = () => {
    window.open(legacyInventoryUrl, "_blank", "noreferrer");
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: theme.tokens.FuelSpacing6,
        flexDirection: "column",
      }}
    >
      <Grid>
        <Typography data-fuel-size="3xl">
          {t("invoices:allInvoices.label.invoices")}
        </Typography>
      </Grid>
      <Grid display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h3">
          {t("invoices:allInvoices.label.allInvoicesHeader")} ({totalInvoices})
        </Typography>
        {showJDPointLegacyButton && (
          <Button
            variant="text"
            onClick={() => openLegacyNewTab()}
            data-testid="legacy-all-invoices"
            endIcon={
              <OpenInNewIcon
                fontSize="small"
                sx={{
                  marginLeft: theme.tokens.FuelSpacing1,
                }}
              />
            }
          >
            {t("invoices:header.navItem.LegacyAllInvoices")}
          </Button>
        )}
      </Grid>
    </Box>
  );
};

export default InvoicesHeader;
